(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-description"] && !Shopify.designMode) return;
  try {
    
class Util {
    static addClass(el, className) {
        const classList = className.split(' ');
        el.classList.add(...classList);
    }

    static removeClass(el, className) {
        const classList = className.split(' ');
        el.classList.remove(...classList);
    }

    static toggleClass(el, className, bool) {
        bool ? Util.addClass(el, className) : Util.removeClass(el, className);
    }

    static setAttributes(el, attrs) {
        for (const key in attrs) {
            el.setAttribute(key, attrs[key]);
        }
    }

    static hasClass(el, className) {
        return el.classList.contains(className);
    }

    static getIndexInArray(array, el) {
        return Array.from(array).indexOf(el);
    }
}

class Tab {
    constructor(element) {
        this.element = element;
        this.tabList = this.element.querySelector('.js-tabs__controls');
        this.listItems = Array.from(this.tabList.querySelectorAll('li'));
        this.triggers = Array.from(this.tabList.querySelectorAll('button'));
        this.panelsList = this.element.querySelector('.js-tabs__panels');
        this.panels = Array.from(this.panelsList.querySelectorAll('.js-tabs__panel'));
        this.hideClass = this.element.getAttribute('data-hide-panel-class') || 'js-tabs__panel--hidden';
        this.customShowClass = this.element.getAttribute('data-show-panel-class') || false;
        this.layout = this.element.getAttribute('data-tabs-layout') || 'horizontal';
        this.deepLinkOn = this.element.getAttribute('data-deep-link') === 'on';
        this.initTab();
        // Uncomment if you have external triggers or prev/next buttons
        // this.initExternalTrigger();
        // this.initPrevNextButtons();
    }

    initTab() {
        this.tabList.setAttribute('role', 'tablist');
        this.element.classList.add('tabs--no-interaction');

        this.triggers.forEach((trigger, index) => {
            const isSelected = index === 0;
            const panelId = trigger.getAttribute('data-panel-id');
            this.listItems[index].setAttribute('role', 'presentation');
            Util.setAttributes(trigger, {
                role: 'tab',
                'aria-selected': isSelected,
                'aria-controls': panelId,
                id: `tab-${panelId}`,
                tabindex: isSelected ? '0' : '-1',
            });
            Util.addClass(trigger, 'js-tabs__trigger');

            const panel = this.panels.find(p => p.getAttribute('data-panel-id') === panelId);
            Util.setAttributes(panel, {
                role: 'tabpanel',
                'aria-labelledby': `tab-${panelId}`,
            });
            Util.toggleClass(panel, this.hideClass, !isSelected);
            if (isSelected && this.customShowClass) Util.addClass(panel, this.customShowClass);
        });

        this.initTabEvents();
        this.initDeepLink();
    }

    initTabEvents() {
        this.tabList.addEventListener('click', (event) => {
            const trigger = event.target.closest('.js-tabs__trigger');
            if (trigger) {
                event.preventDefault();
                this.triggerTab(trigger);
            }
        });

        this.tabList.addEventListener('keydown', (event) => {
            if (!event.target.closest('.js-tabs__trigger')) return;

            if (tabNavigateNext(event, this.layout)) {
                event.preventDefault();
                this.selectNewTab('next');
            } else if (tabNavigatePrev(event, this.layout)) {
                event.preventDefault();
                this.selectNewTab('prev');
            }
        });
    }

    triggerTab(tabTrigger) {
        const index = Util.getIndexInArray(this.triggers, tabTrigger);

        if (this.triggers[index].getAttribute('aria-selected') === 'true') return;

        this.element.classList.remove('tabs--no-interaction');

        this.triggers.forEach((trigger, i) => {
            const isSelected = i === index;
            const panelId = trigger.getAttribute('data-panel-id');
            const panel = this.panels.find(p => p.getAttribute('data-panel-id') === panelId);

            Util.toggleClass(panel, this.hideClass, !isSelected);
            if (this.customShowClass) Util.toggleClass(panel, this.customShowClass, isSelected);
            trigger.setAttribute('aria-selected', isSelected);
            trigger.setAttribute('tabindex', isSelected ? '0' : '-1');
        });

        // Update the URL hash without scrolling
        if (this.deepLinkOn) {
            history.replaceState(null, '', `#${tabTrigger.getAttribute('data-panel-id')}`);
        }
    }

    initDeepLink() {
        if (!this.deepLinkOn) return;
        const hash = window.location.hash.substr(1);
        if (!hash) return;

        const trigger = this.triggers.find(t => t.getAttribute('data-panel-id') === hash);
        if (trigger) {
            this.triggerTab(trigger);
            // Optionally, scroll to the tabs component if desired
            // this.element.scrollIntoView({ behavior: 'auto' });
        }
    }

    selectNewTab(direction) {
        const selectedTab = this.tabList.querySelector('[aria-selected="true"]');
        let index = Util.getIndexInArray(this.triggers, selectedTab);
        index = direction === 'next' ? index + 1 : index - 1;

        if (index < 0) index = this.listItems.length - 1;
        if (index >= this.listItems.length) index = 0;

        this.triggerTab(this.triggers[index]);
        this.triggers[index].focus();
    }

    // Uncomment and implement if you have external triggers
    // initExternalTrigger() {
    //     // Your code for external triggers
    // }

    // Uncomment and implement if you have prev/next buttons inside panels
    // initPrevNextButtons() {
    //     // Your code for prev/next buttons
    // }
}

function tabNavigateNext(event, layout) {
    if (layout === 'horizontal' && (event.keyCode === 39 || event.key === 'ArrowRight')) {
        return true;
    } else if (layout === 'vertical' && (event.keyCode === 40 || event.key === 'ArrowDown')) {
        return true;
    } else {
        return false;
    }
}

function tabNavigatePrev(event, layout) {
    if (layout === 'horizontal' && (event.keyCode === 37 || event.key === 'ArrowLeft')) {
        return true;
    } else if (layout === 'vertical' && (event.keyCode === 38 || event.key === 'ArrowUp')) {
        return true;
    } else {
        return false;
    }
}

// Initialize the tabs
document.querySelectorAll('.js-tabs').forEach((tabElement) => {
    new Tab(tabElement);
});


  } catch(e) { console.error(e); }
})();
})();
